// this file will be replaced by the angular file replacements feature
// returns the 'development' configuration by default;

export * from './.dev';
